module.exports = __webpack_public_path__ + "static/media/filters_launcher.97ccc5be.svg";